import { ChangeDetectionStrategy, Component, Inject, OnInit, ViewEncapsulation } from "@angular/core";
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from "@angular/material/legacy-dialog";
import { SessionLimitNotificationPayload } from "@obg/common.realtime-notifications/customer-limit-notifications/customer-limit-notifications.model";
import { fromMillisecondsToHours, fromMillisecondsToMinutes } from "@obg/ngx.global";

@Component({
	selector: "obg-session-limits-alert-container",
	templateUrl: "./session-limits-alert.container.html",
	styleUrls: ["./session-limits-alert.container.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class SessionLimitsAlertContainer implements OnInit {
	sessionDurationHours: number | undefined;
	sessionDurationMinutes: number | undefined;
	sessionDurationLeftMinutes: number | undefined;

	constructor(@Inject(MAT_DIALOG_DATA) public data: SessionLimitNotificationPayload) {}

	ngOnInit() {
		if (this.data.usedSessionTimeInMillis === undefined || this.data.remainingSessionTimeInMillis === undefined) {
			return;
		}

		this.sessionDurationHours = Math.floor(fromMillisecondsToHours(this.data.usedSessionTimeInMillis));
		this.sessionDurationMinutes = Math.floor(fromMillisecondsToMinutes(this.data.usedSessionTimeInMillis) % 60);
		this.sessionDurationLeftMinutes = Math.ceil(fromMillisecondsToMinutes(this.data.remainingSessionTimeInMillis));
	}
}
